// The number shown on a certificate: its OKL number (for example
// OKL-2026-000123), or the first 8 characters of its id if it has none yet.
// The server uses the same rule (certificateLabel in server/certificateNumbers.js).
export function certificateLabel(certNumber, certId) {
  if (certNumber) return String(certNumber);
  return certId ? String(certId).slice(0, 8).toUpperCase() : '';
}
